
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
export const MatchBanner = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full bg-dark-banner border-b border-white/20 backdrop-blur-sm">
      <div className="container mx-auto px-4 sm:px-6 py-3 sm:py-4">
        {/* Mobile/Tablet: Stacked layout */}
        <div className="md:hidden space-y-4">
          {/* Text content */}
          <div className="text-center space-y-0.5">
            <p className="text-center leading-snug max-w-md mx-auto">
              <span className="text-white text-xs sm:text-sm font-medium">
                Hitta dina perfekta bröllopleverantörer med
              </span>
            </p>
            <p className="text-center leading-snug max-w-md mx-auto">
              <span className="font-bold text-[#A9C6CC] text-sm sm:text-base">
                Den perfekta matchingen!
              </span>
            </p>
            <p className="text-center leading-snug max-w-md mx-auto">
              <span className="text-white text-xs sm:text-sm font-medium">
                Berätta dina önskemål så sätter vi igång.
              </span>
            </p>
          </div>

          {/* Button */}
          <div className="flex justify-center px-4">
            <Button 
              className="bg-[#d5c8b7] hover:bg-[#c5b5a3] border border-white px-5 py-2 rounded-full text-sm font-semibold transition-all duration-300 hover:scale-105 group min-h-[40px] w-auto text-white"
              style={{ textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)' }}
              onClick={() => navigate('/match')}
              aria-label="Starta matchningen för att hitta dina perfekta bröllopleverantörer"
            >
              Matcha nu <span className="ml-2 group-hover:translate-x-1 transition-transform duration-300" aria-hidden="true">→</span>
            </Button>
          </div>
        </div>

        {/* Tablet: Horizontal layout without absolute positioning */}
        <div className="hidden md:flex lg:hidden justify-between items-center gap-4">
          {/* Text content and steps on left */}
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-1 text-sm">
              <span className="text-white font-medium">
                Hitta dina perfekta bröllopleverantörer med
              </span>
              <span className="font-bold text-[#A9C6CC]">Den perfekta matchingen!</span>
              <span className="text-white font-medium">Berätta dina önskemål så sätter vi igång.</span>
            </div>
            {/* Steps on tablet */}
            <div className="flex items-center gap-3 text-xs">
              <div className="flex items-center gap-1.5">
                <div className="bg-white/20 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-semibold shadow-sm">1</div>
                <span className="text-white font-medium">Kontakta leverantörer</span>
              </div>
              <div className="w-6 h-px bg-white/30"></div>
              <div className="flex items-center gap-1.5">
                <div className="bg-white/20 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-semibold shadow-sm">2</div>
                <span className="text-white font-medium">Få offerter</span>
              </div>
              <div className="w-6 h-px bg-white/30"></div>
              <div className="flex items-center gap-1.5">
                <div className="bg-white/20 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-semibold shadow-sm">3</div>
                <span className="text-white font-medium">Boka din leverantör</span>
              </div>
            </div>
          </div>
          
          {/* Button on right */}
          <Button 
            className="bg-[#d5c8b7] hover:bg-[#c5b5a3] border border-white text-white px-5 py-2 rounded-full text-sm font-semibold transition-all duration-300 hover:scale-105 group shrink-0"
            style={{ textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)' }}
            onClick={() => navigate('/match')}
            aria-label="Starta matchningen för att hitta dina perfekta bröllopleverantörer"
          >
            Matcha nu <span className="ml-2 group-hover:translate-x-1 transition-transform duration-300" aria-hidden="true">→</span>
          </Button>
        </div>

        {/* Desktop: Original layout */}
        <div className="hidden lg:block relative">
          <div className="flex justify-center items-center mb-3">
            {/* Text content */}
            <div className="flex flex-col sm:flex-row items-center gap-0.5 text-center">
              <span className="text-white text-sm font-medium">
                Hitta dina perfekta bröllopleverantörer med
              </span>
              <span className="font-bold text-[#A9C6CC] text-sm">Den perfekta matchingen!</span>
              <span className="text-white text-sm font-medium">Berätta dina önskemål så sätter vi igång.</span>
            </div>
          </div>

          {/* Steps */}
          <div className="flex justify-center">
            <div className="flex items-center gap-4 text-sm">
              <div className="flex items-center gap-2">
                <div className="bg-white/20 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-semibold shadow-sm">1</div>
                <span className="text-white font-medium">Kontakta leverantörer</span>
              </div>
              <div className="w-8 h-px bg-white/30"></div>
              <div className="flex items-center gap-2">
                <div className="bg-white/20 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-semibold shadow-sm">2</div>
                <span className="text-white font-medium">Få offerter</span>
              </div>
              <div className="w-8 h-px bg-white/30"></div>
              <div className="flex items-center gap-2">
                <div className="bg-white/20 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-semibold shadow-sm">3</div>
                <span className="text-white font-medium">Boka din leverantör</span>
              </div>
            </div>
          </div>

          {/* Button positioned relative to entire desktop section */}
          <div className="absolute right-0 top-1/2 -translate-y-1/2">
            <Button 
              className="bg-[#d5c8b7] hover:bg-[#c5b5a3] border border-white text-white px-5 py-2 rounded-full text-sm font-semibold transition-all duration-300 hover:scale-105 group"
              style={{ textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)' }}
              onClick={() => navigate('/match')}
              aria-label="Starta matchningen för att hitta dina perfekta bröllopleverantörer"
            >
              Matcha nu <span className="ml-2 group-hover:translate-x-1 transition-transform duration-300" aria-hidden="true">→</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
